/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wise_Soft_Swallow_HurlInputs */

const fr_wise_soft_swallow_hurl = /** @type {(inputs: Wise_Soft_Swallow_HurlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil - Sécurité`)
};

/**

* @param {Wise_Soft_Swallow_HurlInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const wise_soft_swallow_hurl = /** @type {((inputs?: Wise_Soft_Swallow_HurlInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wise_Soft_Swallow_HurlInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_wise_soft_swallow_hurl(inputs)
});